import React from 'react';
import {AlertTriangle} from 'lucide-react';

export function NoShowBadge({count}) {
    if (count === null) return <span className="text-xs text-amber-700">No-show history unavailable</span>;
    if (!Number.isInteger(count) || count < 1) return null;
    return <span data-testid="no-show-badge" className="inline-flex max-w-full items-center gap-1.5 rounded-full border border-amber-600 bg-amber-100 px-3 py-2 text-xs font-semibold text-amber-950" title="Recorded no-show visits, including matched Fresha history">
        <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden="true"/>{count} {count === 1 ? 'no-show' : 'no-shows'}
    </span>;
}
